import { parseISO } from "date-fns";
import moment from "moment";

export const compareDays = (dateOne, dateTwo) => {
  const normalizeDate = () => {
    return parseISO(moment(dateOne).format("YYYY-MM-DD"))
  }
  const dateA = new Date(
    normalizeDate().getYear(),
    normalizeDate().getMonth(),
    normalizeDate().getDate()
  )
  const dateB = new Date(
    dateTwo.getYear(),
    dateTwo.getMonth(),
    dateTwo.getDate()
  )

  if (dateA.getTime() > dateB.getTime()) {
    return false
  }

  if (dateA.getTime() < dateB.getTime()) {
    return true
  }

  return false
}

export const getQuotaDates = (quotas) => {
  return {
    fe_id: quotas.fe_id,
    dates: quotas?.dates
      .filter(item => compareDays(item.date, new Date()) === false)
      .map((item) => {
        return item.date
      })
  }
}

export const generateFullWeek = (ref) => {
  let fullWeek = [];
  for (let i = 0; i < 7; i++) {
    fullWeek.push({date: moment(ref).clone().weekday(i).format('YYYY-MM-DD')})
  }
  return fullWeek;
}

export const getTodayDate = () => {
  return new Date().toLocaleDateString('en-CA');
}
